module.exports = __webpack_public_path__ + "static/media/noun_cocktail.942dec14.svg";